const $ = jQuery.noConflict();

const loadMorePosts = function(wrapper, trigger) {

	const data = {
		'action': 'ohh_loadmore_products',
		'query': OHHSTORE.posts,
		'page' : OHHSTORE.current_page,
		'nonce' : WP.ajaxNonce
	};

	$.ajax({
		url : WP.ajaxUrl,
		data : data,
		type : 'POST',

		beforeSend : function ( xhr ) {
			trigger.textContent = 'Loading...';
		},

		success : function( data ){
			if( data ) {
				trigger.blur();
				trigger.textContent = 'Load more';
				wrapper.previousElementSibling.insertAdjacentHTML('beforeend', JSON.parse(data));

				OHHSTORE.current_page++;

				if ( OHHSTORE.current_page == OHHSTORE.max_page ) {
					wrapper.remove();
				}
			} else {
				wrapper.remove();
			}
			trigger.classList.remove('loading');
		}
	});
}

const woocommerceAjaxLoadMoreInit = function() {
	const loadMoreTriggerWrap = document.querySelector('.woo-load-more-wrap');

	if(loadMoreTriggerWrap === null) {
		return;
	}

	const loadMoreTrigger = loadMoreTriggerWrap.querySelector('.woo-load-more-trigger');

	loadMoreTrigger.addEventListener('click', (e) => {
		e.preventDefault();

		if(loadMoreTrigger.classList.contains('loading')) {
			return;
		}

		loadMoreTrigger.classList.add('loading');
		loadMorePosts(loadMoreTriggerWrap, loadMoreTrigger);
	});
}

export default woocommerceAjaxLoadMoreInit;